module.exports = __webpack_public_path__ + "img/united-states.27414395.svg";